module.exports = __webpack_public_path__ + "static/media/nat-1.95167fea.jpg";